
export const ATTORNEY_TITLE_ENTITY_TYPE = 'AttorneyTitleEntity';
export const BORROWER_ENTITY_AUTOMATION_SUCCESS_STATUS = "SUCCESS";
export const BORROWER_ENTITY_AUTOMATION_IN_PROGRESS_STATUS = "IN_PROGRESS";
